function changeQuantity(input, step) {
  if (!input) return;

  let quantity = parseInt(input.value) || 1;
  const min = parseInt(input.min) || 1;
  const max = parseInt(input.max) || Number.MAX_VALUE;

  let newQuantity = quantity + step;

  if (newQuantity < min) newQuantity = min;
  if (newQuantity > max) newQuantity = max;

  input.value = newQuantity;

  // Atualize a quantidade no campo do formulário de produto
  const form = input.closest('form');
  if (form) {
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = newQuantity; // Atualiza o valor da quantidade no formulário
    }
  }

  // Dispara eventos para atualizar o tema e o input
  input.dispatchEvent(new Event('change', { bubbles: true }));
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

// Delegação de evento para funcionar após a troca de variante
document.addEventListener('click', function(event) {
  const increaseButton = event.target.closest('.quantity-selector__button.aumentar');
  if (increaseButton) {
    event.preventDefault(); 
    const selector = increaseButton.closest('quantity-selector');
    if (selector) {
      const input = selector.querySelector('input.quantity-selector__input');
      changeQuantity(input, 1);
    }
    return;
  }

  const decreaseButton = event.target.closest('.quantity-selector__button.diminuir');
  if (decreaseButton) {
    event.preventDefault(); 
    const selector = decreaseButton.closest('quantity-selector');
    if (selector) {
      const input = selector.querySelector('input.quantity-selector__input');
      changeQuantity(input, -1);
    }
  }
});


// Lógica para lidar com digitação manual
function handleManualInput(event) {
  if (event.target.matches('input.quantity-selector__input')) {
    const input = event.target;
    input.style.setProperty("--quantity-input-characters-count", `${input.value.toString().length}ch`);
  }
}

// Lógica para validar e corrigir entrada manual
function validateManualInput(event) {
  if (event.target.matches('input.quantity-selector__input')) {
    const input = event.target;
    let quantity = parseInt(input.value);
    const min = parseInt(input.min) || 1;
    const max = parseInt(input.max) || Number.MAX_VALUE;

    if (isNaN(quantity) || quantity < min) input.value = min;
    else if (quantity > max) input.value = max;

    handleManualInput(event);
  }
}

document.addEventListener('input', handleManualInput);
document.addEventListener('change', validateManualInput);
